import { DatePicker } from "./date-picker";

export class PostFiltersModule {
    initialize() {
        this.rootElement = document.querySelector('.post-filters');
        if (!this.rootElement) return;

        this.query = new URLSearchParams(window.location.search);
        this.checkIfParamsAreValid();

        this.postFilters = this.rootElement.querySelectorAll(".post-filter");
        this.dateFilter = this.rootElement.querySelector(".date-picker");

        this.datePicker = null;

        this.addEventListeners();
    }

    checkIfParamsAreValid() {
        // If there is a reset tag, remove the tag query parameter
        if(this.rootElement.dataset.resetTag) {
            this.query.delete('tag');
            this.updateUrl();
            return;
        }
    }

    addEventListeners() {
        // Add event listeners to all main and sub filters
        Array.from(this.postFilters).forEach(filter => {
            filter.addEventListener("change", (event) => {
                this.onFilterChange(filter, event);
            });
        });

        // Custom logic for date filter
        const initialDate = this.query.get('date');
        const locale = this.rootElement.dataset.locale;
        this.datePicker = new DatePicker(this.dateFilter, initialDate, this.onSelectDate.bind(this), locale);
    }

    onFilterChange(filter, event) {
        // Main filter (for example category) has a url as value
        // Sub filters (for example tag) have a query as value
        // Check if the filter is a main filter or a sub filter and set the filterType accordingly
        const filterType = filter.classList.contains("post-filter-url") ? "url" : "query";

        if (filterType === "url") {
            // If the filter is a main filter, redirect to the url
            const urlWithQuery = `${filter.value}?${window.location.search}`;
            window.location.href = urlWithQuery;
        } else {
            // If the filter is a sub filter, add the query parameter to the url
            const filterName = filter.name;
            const filterValue = filter.value;

            if (filterValue === "reset" || filterValue === "") {
                this.query.delete(filterName);
            } else {
                this.query.set(filterName, filterValue);
            }

            this.updateUrl();
        }
    }

    onSelectDate(date) {
        // If a date is selected, add the date to the query parameters
        if (date) {
            const day = date.getDate().toString().padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const year = date.getFullYear();
            const formattedDate = `${day}/${month}/${year}`;
            
            this.query.set('date', formattedDate);
            this.updateUrl();
        } else {
            this.query.delete('date');
            this.updateUrl();
        }
    }

    updateUrl() {
        const newUrl = `${window.location.pathname}?${this.query.toString()}`;
        window.location.href = newUrl;
    }
}